import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enCommon from "./locales/en/common.json";
import enDashboard from "./locales/en/dashboard.json";
import deCommon from "./locales/de/common.json";
import deDashboard from "./locales/de/dashboard.json";
import frCommon from "./locales/fr/common.json";
import frDashboard from "./locales/fr/dashboard.json";
import esCommon from "./locales/es/common.json";
import esDashboard from "./locales/es/dashboard.json";
import etCommon from "./locales/et/common.json";
import etDashboard from "./locales/et/dashboard.json";
import fiCommon from "./locales/fi/common.json";
import fiDashboard from "./locales/fi/dashboard.json";

export const SUPPORTED_LANGUAGES = ["en", "de", "fr", "es", "et", "fi"] as const;
export type AppLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const LANGUAGE_META: Record<AppLanguage, { label: string; flag: string }> = {
  en: { label: "English", flag: "🇬🇧" },
  de: { label: "Deutsch", flag: "🇩🇪" },
  fr: { label: "Français", flag: "🇫🇷" },
  es: { label: "Español", flag: "🇪🇸" },
  et: { label: "Eesti", flag: "🇪🇪" },
  fi: { label: "Suomi", flag: "🇫🇮" },
};

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { common: enCommon, dashboard: enDashboard },
      de: { common: deCommon, dashboard: deDashboard },
      fr: { common: frCommon, dashboard: frDashboard },
      es: { common: esCommon, dashboard: esDashboard },
      et: { common: etCommon, dashboard: etDashboard },
      fi: { common: fiCommon, dashboard: fiDashboard },
    },
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LANGUAGES as unknown as string[],
    nonExplicitSupportedLngs: true,
    ns: ["common", "dashboard"],
    defaultNS: "common",
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      lookupLocalStorage: "i18nextLng",
      caches: ["localStorage"],
    },
    returnNull: false,
  });

export default i18n;